import React, { useCallback } from "react";
import { CheckboxButton, QuestionContainer, QuestionTitle, Square } from "./style";

export const ReportQuestion = ({
  // Titulo da pergunta
  questionTitle,
  // Id da pergunta
  questionId,
  // Prop para controlar a renderização do checkbox 
  hasCheckbox = true,
  // Prop para checkbox
  checked = false,
  // Prop para seleção da perguntaa
  selected = false,
  // callback do check
  onCheck,
  // callback do select
  onSelect
}) => {

  // Controla o estado do checkbox
  const handleCheckQuestion = useCallback(() => {
    if(onCheck) {
      onCheck(questionId);
    }
  }, [questionId]);

  // Persiste a pergunta selecionada
  const handleSelectedQuestion = useCallback(() => {
    if(onSelect) {
      onSelect(questionId);
    }
  }, [questionId]);

  return (
    <QuestionContainer selected={selected} onClick={handleSelectedQuestion}>
        {hasCheckbox && 
          <CheckboxButton onClick={handleCheckQuestion}>
            <Square isChecked={checked} />
          </CheckboxButton>
        }
      <QuestionTitle isQuestion={hasCheckbox} >{questionTitle}</QuestionTitle>
    </QuestionContainer>
  );
};
